import React from "react";
import "./WhyChooseRecla.css";

const WhyChooseRecla = () => {
  const items = [
    { id: "01", title: "Premium Quality & Performance"},
    { id: "02", title: "30-Day Delivery on Bulk Orders"},
    { id: "03", title: "Eco-Friendly Manufacturing   "},
    { id: "04", title: "Dedicated Technical Support"},
    { id: "05", title: "Direct Manufacturer Pricing"},
  ];

  return (
    <section className="ps-why">
      <h2>Why Choose Recla</h2>
      <div className="hex-container">
        {items.map((item, index) => (
          <div key={index} className="hex-box">
            <div className="hex-shape">
              <div className="hex-content">
                <div className="hex-number">{item.id}</div>
                <div className="hex-icon">{item.icon}</div>
                <h3>{item.title}</h3>
              </div>
            </div>
            {index !== items.length - 1 && <div className="arrow">→</div>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseRecla;
